// ─── DiscoveryFlagToggle — extracted from AdminCCFSLeads.jsx (Phase 1) ───
// Pure display. Amber/Red flag toggle (notification-style); no API, no own state.

import { Flag } from 'lucide-react';

export function DiscoveryFlagToggle({ value, onChange, testId }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      <button
        type="button"
        onClick={() => onChange(value === 'amber' ? null : 'amber')}
        title="Amber flag — note explanation needed during Discovery Call"
        className={`w-5 h-5 rounded flex items-center justify-center border transition-colors ${
          value === 'amber'
            ? 'bg-amber-500 border-amber-600 text-white shadow-sm'
            : 'bg-amber-50 border-amber-300 text-amber-500 hover:bg-amber-100 hover:border-amber-400'
        }`}
        data-testid={testId ? `${testId}-amber` : undefined}
      >
        <Flag className="w-2.5 h-2.5" fill={value === 'amber' ? 'currentColor' : 'none'} />
      </button>
      <button
        type="button"
        onClick={() => onChange(value === 'red' ? null : 'red')}
        title="Red flag — detailed discussion / investigation required"
        className={`w-5 h-5 rounded flex items-center justify-center border transition-colors ${
          value === 'red'
            ? 'bg-red-500 border-red-600 text-white shadow-sm'
            : 'bg-red-50 border-red-300 text-red-500 hover:bg-red-100 hover:border-red-400'
        }`}
        data-testid={testId ? `${testId}-red` : undefined}
      >
        <Flag className="w-2.5 h-2.5" fill={value === 'red' ? 'currentColor' : 'none'} />
      </button>
    </div>
  );
}
